/* eslint-disable no-extend-native */

String.prototype.formatDate = function (): string {
  if (!this) return "";
  const newDate = new Date(this);
  return newDate.toLocaleDateString("pt-BR");
};

String.prototype.isEquals = function (value: string): boolean {
  if (typeof value !== "string") return false;
  return this === value;
};

export {};
